import React from 'react';
import { RateCard } from '../RateCard/RateCard';
import styles from './RatesList.module.scss';
import Service from 'model/Service';

interface RatesListProps {
    boardingServices: Service[];
}

export const RatesList: React.FC<RatesListProps> = ({ boardingServices }) => {
    return (
        <div className={styles.container}>
            {boardingServices.map(service => (
                <RateCard
                    key={service.id}
                    boardingService={service}
                />
            ))}
        </div>
    );
};
